import { generateAPI } from "../api.generator";

export const getDdayInsights = generateAPI<
  {},
  {
    pageviews: number;
    posts: number;
  }
>("get", "wedding/dday-insights");
